import { render, staticRenderFns } from "./AgreementPopup.vue?vue&type=template&id=042bb6c3&"
import script from "./AgreementPopup.vue?vue&type=script&lang=js&"
export * from "./AgreementPopup.vue?vue&type=script&lang=js&"
import style0 from "./AgreementPopup.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports